import { getGuid } from 'owa-guid';
import { lazySetCollabSpaceViewStateId } from 'owa-calendar-compose-form-store';

export function createCollabSpaceViewStateId(formId: string): string {
    const viewStateId = formId ?? getGuid();
    lazySetCollabSpaceViewStateId.importAndExecute(viewStateId, formId);
    return viewStateId;
}
